export default __webpack_public_path__ + "static/media/telcarnet.e72b680b.mp4";